import React from 'react';
import { IItemForGetShortInfo, IItemForGetShortDishInfo } from 'types';
import { ModificationDishMultipleSelect } from './components/ModificationDishMultipleSelect';
import { DnDList } from './components/DnDList';
import style from './index.module.scss';

interface IProps {
	setFetchedModificationDishSubCategories: (value: IItemForGetShortInfo[]) => void;
	setFetchedModificationDishes: (value: IItemForGetShortInfo[]) => void;
	setModificationDishCategory: (value: Nullable<string>) => void;
	setModificationDishSubCategory: (value: Nullable<string>) => void;
	setModificationDishes: (value: string[]) => void;
	removeModificationDish: (value: string) => void;
	IDsSelectedRestaurant: string[];
	selectedModificationDishCategory: Nullable<string>;
	selectedModificationDishSubCategory: Nullable<string>;
	selectedModificationDishes: string[];
	fetchedModificationDishes: IItemForGetShortDishInfo[];
}

export const ModificationDishesField: React.FC<IProps> = React.memo(
	({
		setFetchedModificationDishSubCategories,
		setFetchedModificationDishes,
		setModificationDishCategory,
		setModificationDishSubCategory,
		setModificationDishes,
		removeModificationDish,
		IDsSelectedRestaurant,
		selectedModificationDishCategory,
		selectedModificationDishSubCategory,
		selectedModificationDishes,
		fetchedModificationDishes,
	}) => {
		return (
			<div className={style.container} data-test="ModificationDishesField">
				<ModificationDishMultipleSelect
					setFetchedModificationDishSubCategories={setFetchedModificationDishSubCategories}
					setFetchedModificationDishes={setFetchedModificationDishes}
					setModificationDishCategory={setModificationDishCategory}
					setModificationDishSubCategory={setModificationDishSubCategory}
					setModificationDishes={setModificationDishes}
					removeModificationDish={removeModificationDish}
					IDsSelectedRestaurant={IDsSelectedRestaurant}
					selectedModificationDishCategory={selectedModificationDishCategory}
					selectedModificationDishSubCategory={selectedModificationDishSubCategory}
					fetchedModificationDishes={fetchedModificationDishes}
					selectedModificationDishes={selectedModificationDishes}
				/>
				<DnDList
					selectedModificationDishes={selectedModificationDishes}
					fetchedModificationDishes={fetchedModificationDishes}
					setModificationDishes={setModificationDishes}
					removeModificationDish={removeModificationDish}
				/>
			</div>
		);
	},
);
